import BaseModalV2 from "../../modals/base_modal_v2";
import React, { useContext, useState, useEffect } from "react";
import { useComponentDidMount } from "../../../lib/hook";
import { Button, Col, Grid, Row } from "react-bootstrap";
import { connect, useSelector } from "react-redux";
import { createCampaignItems, getCampaignsForUser } from "../../../action_managers/campaigns";
import { UserContext } from "../../app";
import head from "lodash/head";
import map from "lodash/map";
import isEmpty from "lodash/isEmpty";

import { showModal } from "../../../actions/modal";
import { POST_ACTION_MODAL } from "../../modals/modal_root";
import { If } from "react-extras";
import { Link } from "react-router-dom";

const AddToCampaignModalFooter = props => {
  const { campaign, close, createCampaignItems, show, showPostAction } = props;

  const submit = () => {
    createCampaignItems(campaign.uuid, [{ showUUID: show.uuid }]).then(resp => {
      if (resp.status === 200) {
        close();
        showPostAction();
      }
    });
  };

  return (
    <Grid fluid>
      <Row>
        <Col xs={10} md={5} xsOffset={1}>
          <Button className="btn btn-secondary width-100" onClick={close}>
            Cancel
          </Button>
        </Col>
        <Col xs={10} md={5}>
          <Button
            className="btn btn-primary width-100"
            onClick={submit}
            disabled={isEmpty(campaign)}>
            Add
          </Button>
        </Col>
      </Row>
    </Grid>
  );
};

const AddToCampaignModalContent = props => {
  const { selectedCampaign, setSelectedCampaign, campaigns } = props;

  const isLoading = useSelector(state => state.campaigns.isLoading);
  if (isLoading) {
    return null;
  }

  const options = campaigns.map(campaign => {
    return (
      <option key={campaign.uuid} value={campaign.uuid}>
        {campaign.name}
      </option>
    );
  });

  return (
    <Grid fluid>
      <Row>
        <Col xs={10} xsOffset={1}>
          <label className="redcircle-form-label">CAMPAIGN</label>
          <If condition={isEmpty(campaigns)}>
            <select className="form-control" disabled />
            <p className="margin-top--small">
              It looks like you don't have any campaigns to add to. You can create a new one{" "}
              <Link to="/campaigns/new">
                <b>here</b>
              </Link>
              .
            </p>
          </If>
          <If condition={!isEmpty(campaigns)}>
            <select
              className="form-control"
              value={selectedCampaign}
              onChange={e => setSelectedCampaign(e.target.value)}>
              {options}
            </select>
          </If>
        </Col>
      </Row>
    </Grid>
  );
};

const AddToCampaignModal = props => {
  const { close, getCampaignsForUser, createCampaignItems, show, showPostAction } = props;
  const user = useContext(UserContext);
  const userCampaignUUIDs = useSelector(state => state.campaigns.campaignsForUser);
  const campaignByUUID = useSelector(state => state.campaigns.campaigns);
  const userCampaigns = map(userCampaignUUIDs, campaignUUID => {
    return campaignByUUID[campaignUUID];
  });
  const [selectedCampaign, setSelectedCampaign] = useState(head(userCampaignUUIDs));

  useEffect(() => {
    setSelectedCampaign(head(userCampaignUUIDs));
  }, [userCampaignUUIDs]);

  useComponentDidMount(() => {
    getCampaignsForUser(user.uuid);
  }, []);

  return (
    <BaseModalV2
      close={close}
      isMini={true}
      hideMiniTitleDivider={false}
      showContent={true}
      noFooterShadow={true}
      title="Add to Campaign"
      subTitle={
        <span>
          Select the campaign you'd like to add the show <b>{show.title}</b> to below
        </span>
      }
      Content={
        <AddToCampaignModalContent
          selectedCampaign={selectedCampaign}
          setSelectedCampaign={setSelectedCampaign}
          campaigns={userCampaigns}
        />
      }
      Footer={
        <AddToCampaignModalFooter
          campaign={campaignByUUID[selectedCampaign]}
          createCampaignItems={createCampaignItems}
          show={show}
          close={close}
          showPostAction={showPostAction}
        />
      }
    />
  );
};

export default connect(state => ({}), {
  getCampaignsForUser,
  createCampaignItems,
  showPostAction: () =>
    showModal(POST_ACTION_MODAL, { message: "Added to Campaign", timeout: 1000 }),
})(AddToCampaignModal);
